export default __webpack_public_path__ + "static/media/StartPic.7d195f37.png";